import { Close } from '@mui/icons-material';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { useMessageForwardDialogLogic } from '../hooks/use-message-forward-dialog-logic';
import { ConversationListForward } from './message-forward/conversation-list-forward';
import { SearchBarForward } from './message-forward/search-bar-forward';
import { UserListForward } from './message-forward/user-list-forward';

interface MessageForwardDialogProps {
  conversationId: string;
}

export const MessageForwardDialog: React.FC<MessageForwardDialogProps> = ({ conversationId }) => {
  const {
    show,
    message,
    isForwarding,
    searchQuery,
    handleSearchChange,
    sentConversations,
    handleConversationSend,
    handleConversationUndo,
    sentUsers,
    handleUserSend,
    handleUserUndo,
    handleDialogClose
  } = useMessageForwardDialogLogic();

  if (!message) return null;

  return (
    <Dialog
      open={show}
      onClose={handleDialogClose}
      maxWidth='sm'
      fullWidth
      slotProps={{
        paper: {
          sx: {
            maxHeight: '80svh',
            minHeight: '80svh',
            width: '480px',
            maxWidth: '480px',
            minWidth: '480px'
          }
        }
      }}
    >
      <DialogTitle className='mex:!p-2'>
        <Box className='mex:flex mex:items-center mex:justify-between '>
          <Typography variant='h6' component='div' className='mex:font-bold mex:text-gray-800'>
            Chuyển tiếp tin nhắn
          </Typography>
          <IconButton onClick={handleDialogClose} disabled={isForwarding} size='small' color='error'>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent className='mex:!p-0 mex:!overflow-hidden mex:!flex mex:!flex-col'>
        {/* Search Bar */}
        <SearchBarForward onSearchChange={handleSearchChange} />

        {/* Content - Scrollable with fixed height */}
        <Box className='mex:overflow-y-auto' sx={{ flex: 1 }}>
          {/* Recent Conversations */}
          <ConversationListForward
            conversationId={conversationId}
            searchQuery={searchQuery}
            sentConversations={sentConversations}
            onConversationSend={handleConversationSend}
            onConversationUndo={handleConversationUndo}
          />

          {/* Users */}
          <UserListForward
            searchQuery={searchQuery}
            sentUsers={sentUsers}
            onUserSend={handleUserSend}
            onUserUndo={handleUserUndo}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};
